import React from "react";
import { Helmet } from "react-helmet-async";
import { COMPANY } from "@/lib/api";

export function SEO({ title, description, path = "/", lang = "it", jsonLd, noindex = false }) {
  const fullTitle = `${title} · ${COMPANY.name}`;
  const url = `https://bagnoman.it${path}`;
  const robotsContent = noindex ? "noindex, nofollow" : "index, follow";
  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robotsContent} />
      <meta name="theme-color" content="#1394B9" />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={lang === "it" ? "it_IT" : "en_US"} />
      <meta name="twitter:card" content="summary_large_image" />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export default SEO;
